import React from 'react';
import { styled } from '@volkswagen-onehub/components-core';
import { keyframes } from 'styled-components';

const lineKeyframe = keyframes`
  from {
    transform: translateY(-120%);
  }
  to {
    transform: translateY(100%);
  }
`;

const VerticalLineWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  margin-top: 24px;
  overflow: hidden;
`;
const Line = styled.div`
  height: 44px;
  width: 2px;
  background-color: #001e50;
  animation: ${lineKeyframe} 1.75s infinite;
`;

export const VerticalLine = () => {
  return (
    <VerticalLineWrapper>
      <Line />
    </VerticalLineWrapper>
  );
};
